export type NotificationPollingConfig = {
  /** Steady cadence. The agreed v1 makes this remotely configurable so load can be backed off without a release. */
  intervalMs: number
  /**
   * Whether a run in flight is polled harder. Set `false` to fall back to the single interval — the
   * faster rate is a judgement call about load, and this is the one line that reverses it.
   */
  fastPollEnabled: boolean
  fastIntervalMs: number
  /** Past this, a job that hasn't moved is stuck rather than busy, and stops earning the faster rate. */
  inFlightWindowMs: number
  /** Rows the arrival probe reads; only the top of the unread list can hold an arrival. */
  probeSize: number
}

export const NOTIFICATION_POLLING: NotificationPollingConfig = {
  intervalMs: 45000,
  fastPollEnabled: true,
  fastIntervalMs: 5000,
  inFlightWindowMs: 15 * 60 * 1000,
  probeSize: 10,
}

/** RTK Query reads 0 as "don't poll". */
export const POLL_DISABLED = 0

/**
 * The whole polling policy, in one pure function: a hidden tab never polls, a run in flight is watched
 * closely when that is switched on, everything else takes the steady cadence. Changing the mechanic —
 * backing off as a long run drags on, say — is a change here and to these tests, and nowhere else.
 * It all goes away when the transport becomes SSE.
 */
export const pollIntervalFor = (
  { isVisible, isRunInFlight }: { isVisible: boolean; isRunInFlight: boolean },
  config: NotificationPollingConfig = NOTIFICATION_POLLING
): number => {
  if (!isVisible) return POLL_DISABLED
  if (isRunInFlight && config.fastPollEnabled) return config.fastIntervalMs
  return config.intervalMs
}
